var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container header_auth_main"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('HeaderMainLogo')],1),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"header_auth_main_back"},[_c('span',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Вернуться назад")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }